var transform = {
  serializeIn: function serializeIn(settings) {
    var yScaleSettings = settings.yScaleSettings,
        theme = settings.theme;
    return {
      verticalGrid: theme.gridX.enabled,
      horizontalGrid: theme.gridY.enabled,
      xAxisTitle: settings.xAxisTitle,
      yAxisTitle: settings.yAxisTitle,
      formatValue: typeof (yScaleSettings === null || yScaleSettings === void 0 ? void 0 : yScaleSettings.formatLabel) === 'string' ? yScaleSettings.formatLabel : null
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue,
        xAxisTitle = _ref.xAxisTitle,
        yAxisTitle = _ref.yAxisTitle,
        verticalGrid = _ref.verticalGrid,
        horizontalGrid = _ref.horizontalGrid;
    return {
      xAxisTitle: xAxisTitle,
      yAxisTitle: yAxisTitle,
      yScaleSettings: {
        type: 'linear',
        formatLabel: formatValue
      },
      tooltipSettings: {
        formatValue: formatValue
      },
      theme: {
        gridY: {
          enabled: horizontalGrid
        },
        gridX: {
          enabled: verticalGrid
        }
      }
    };
  }
};
export default transform;